export default __webpack_public_path__ + "static/media/github.bda3bc8d.jpg";